var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"name-cell"},[_c('div',{staticClass:"name",on:{"click":function($event){$event.stopPropagation();return _vm.openIssue.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.displayName)+" ")]),(_vm.item && _vm.displaySubtitle)?_c('div',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }